const customStyles = (theme) => ({
    card: {
        border: "1px solid #F4F4F4",
        boxSizing: "border-box",
        boxShadow: "0px 1px 18px rgb(0 0 0 / 4%)",
        // borderRadius: "11px",
        padding: 10,
    },
    indicator: {
        backgroundColor: "#00838F",
    },
    cardContent: {
        paddingBottom: "5px !important",
        height: 'calc(100% - 40px)'
    },
    root: {
        boxShadow: "none !important"
    },
    status: {
        background: "#FFD0D0",
        boxShadow: "0px 1px 18px rgba(0, 0, 0, 0.04)",
        borderRadius: "6px",
        color: "#D73F3F",
        padding: "3px 15px",
        width: "115px"
    },
    cardHead: {
        fontWeight: 600,
        fontSize: "14px",
        padding: "5px"
    },
    gridItem: {
        position: "relative",
        marginTop: "10px",
        "& .MuiPaper-rounded": {
            borderRadius: '0px',
        },
        "& .MuiPaper-root": {
            height: '100% !important',

        }
    },
    // Wrapper:{
    //     "& ..MuiTab-wrapper":{
    //         fontFamily:'Segoe UI',
    //     }
    // },
    img: {
        position: "absolute",
        right: "25px",
        top: "-10px"
    },
    indicator: {
        backgroundColor: "#00838F",
    },
    // button: {
    //     background: "#FFFFFF",
    //     border: "none",
    //     // border: "1px solid #EEEDED",
    //     boxSizing: "border-box",
    //     borderRadius: "7px",
    //     padding: "5px 10px"
    // },
    fontIcon: {
        paddingLeft: "10px",
        borderLeft: "1px solid #EEEDED"
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& .MuiFormHelperText-contained ': {
            marginLeft: "5px !important",
            marginTop: "-10px !important",
            fontSize: '23px !important',
            color: '#DD0000'
        },
    },
    helperText1: {
        '& .MuiFormHelperText-contained ': {
            fontFamily: 'Segoe UI !important',
            marginLeft: "0px !important",
            fontSize: '12px !important',
            color: '#DD0000'
        },
    },
    MuiFormHelperTextcontained: {
        marginLeft: "8px !important",
        marginTop: "-10px !important",
        fontSize: '23px !important',
        color: '#DD0000',
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    dragIcon: {
        width: 30,
        height: 32,
        margin: "3px 0",
        "& path": {
            fill: "#B6B6B6"
        }
    },
    fontIcon: {
        paddingRight: "8px",
    },
    linkButton: {
        background: "#4DAA57",
        color: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: 0,
        height: 29,
        width: 77,
        minWidth: 77,
        maxWidth: 77,
    },
    whiteButton: {
        background: "#FFFFFF",
        color: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: 0,
        height: 29,
        width: 77,
        minWidth: 77,
        maxWidth: 77,
    },
    whiteButtonYard: {
        background: "#F3F3F3",
        // color: "#FFFFFF",
        color: "#F3F3F3",
        border: "none",
        boxSizing: "border-box",
        borderRadius: 0,
        height: 26,
        width: 77,
        minWidth: 77,
        maxWidth: 77,
    },
    enterButton: {
        background: "#F3F3F3",
        color: "#B2B0B0",
        border: "none",
        boxSizing: "border-box",
        borderRadius: 0,
        padding: 0,
        height: 29,
        width: 77,
        minWidth: 77,
        maxWidth: 77,
    },
    completed: {
        background: "#94DAA8",
        color: "#0C822C",
        border: "none",
        boxSizing: "border-box",
        borderRadius: 0,
        height: 18,
        width: 75,
    },
    filter: {
        width: '300px',
    },
    UnButton: {
        background: "#EF8354",
        color: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: 0,
        height: 29,
        width: 77,
        minWidth: 77,
        maxWidth: 77,
    },
    PENDING: {
        background: "#FED19B",
        color: "#BB6C0F",
        border: "none",
        boxSizing: "border-box",
        borderRadius: 0,
        height: 18,
        width: 60
    },
    Overtime: {
        background: "#FED19B",
        color: "#BB6C0F",
        border: "none",
        padding: 2,
        boxSizing: "border-box",
        borderRadius: 0,
        height: 20,
        width: 105
    },
    inputfieldAlign: {
        "& fieldset": {
            top: "-1px !important",
        }
    },
    pagination: {
        background: "#F6F6F6",
        height: "40px",
        position: "fixed",
        bottom: 0,
        width: '100%',
        color: "#000000",
        fontWeight: "bold",
        margin: "auto",
    },
    paginationAlign: {
        background: "#F6F6F6",
        height: "40px",
        position: "fixed",
        bottom: 0,
        // width: '100%',
        width: 'calc(100% - 240px) !important',
        color: "#000000",
        fontWeight: "bold",
        margin: "auto",
    },
    paginationNormal: {
        background: "#F6F6F6",
        height: "40px",
        // position: "fixed",
        bottom: 0,
        width: '100%',
        color: "#000000",
        fontWeight: "bold",
        margin: "auto",
    },
    paginationItem: {
        float: "right",
        marginRight: "13px",
        marginTop: "11px",
    },
    arrow: {
        fontSize: "15px",
        color: "#000000",
        cursor: "pointer"
    }
});
export default customStyles;
